import cn from 'classnames'
import TooltipIcon from 'ext-ui/components/TooltipIcon/TooltipIcon'
import React, { ComponentProps, ReactElement } from 'react'
import LoadingShimmer from 'src/components/LoadingShimmer/LoadingShimmer'

import style from './StatisticsBox.style'

export type StatisticsBoxProps = {
  className?: string
  icon?: ReactElement
  label: string
  tooltipCopy?: string
  value: number
  active?: boolean
  isLoading: boolean
} & Omit<ComponentProps<'div'>, 'children'>

function StatisticsBox(props: StatisticsBoxProps): ReactElement {
  const {
    className = '',
    icon,
    label,
    tooltipCopy,
    value,
    active,
    isLoading,
  ...rest
  } = props

  return (
    <div
      className={cn('StatisticsBox', className, { active })}
      css={style}
      {...rest}
    >
      <div className="StatisticsBox-header">
        <div className="StatisticsBox-header-left">
          {icon}
          <div className="StatisticsBox-header-left-label">
            {label}
          </div>
        </div>
        {tooltipCopy && (
          <TooltipIcon className="StatisticsBox-header-tooltip">
            {tooltipCopy}
          </TooltipIcon>
        )}
      </div>
      <div className="StatisticsBox-value">
        {isLoading ? <LoadingShimmer width={'40px'} height={'36px'} /> : value}
      </div>
    </div>
  )
}

export default StatisticsBox
